import ListInput from './component';

export default {
  component: ListInput,
  specialProps: (props = {}) => ({
    required: props.required && !props.value.length
  }),
};
